/* Parent labels navigate normally; hover and keyboard reveal their child links. */
(() => {
  function init(root = document) {
    for (const menu of root.querySelectorAll('[data-sf-nav-menu]')) {
      if (menu.dataset.sfNavReady) continue;
      menu.dataset.sfNavReady = 'true';
      const parent = menu.querySelector('[data-sf-nav-parent]');
      const submenu = menu.querySelector('[data-sf-nav-submenu]');
      if (!parent || !submenu) continue;
      let closeTimer;
      const close = () => {
        clearTimeout(closeTimer);
        submenu.hidden = true;
        parent.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        clearTimeout(closeTimer);
        for (const other of document.querySelectorAll('[data-sf-nav-parent][aria-expanded="true"]')) {
          if (other !== parent) {
            other.setAttribute('aria-expanded', 'false');
            other.parentElement.querySelector('[data-sf-nav-submenu]').hidden = true;
          }
        }
        submenu.hidden = false;
        parent.setAttribute('aria-expanded', 'true');
      };
      menu.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') open(); });
      menu.addEventListener('pointerleave', () => {
        closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 120);
      });
      menu.addEventListener('focusin', open);
      menu.addEventListener('focusout', (event) => { if (!menu.contains(event.relatedTarget)) close(); });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          parent.focus();
          close();
        } else if (event.key === 'ArrowDown' && event.target === parent) {
          event.preventDefault();
          open();
          submenu.querySelector('a[href]')?.focus();
        }
      });
      document.addEventListener('pointerdown', (event) => { if (!menu.contains(event.target)) close(); });
      // Enter and clicks retain the anchor's native navigation, including modifiers.
    }
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
